import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ProductCreateSelectTypePage } from '../../../products/product-create/product-create-select-type/product-create-select-type';
import { StockServices } from '../../../stock/services';

@Component({
  selector: 'page-tutorial-stock',
  templateUrl: 'tutorial-stock.html',
})
export class TutorialStockPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public stockServices: StockServices,) {

  }

  close() {
    /*this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_stock': true,
    }).then(() => {
      this.navCtrl.pop();
    });*/
    this.navCtrl.pop();
  }

  createProduct() {
    var total_products = this.stockServices.ingprod_array_tmp.filter(element => element.type == 'product');
    if (total_products.length >= this.globals.checkLimitsByLicense('stock', 'ings_prods') && this.globals.checkLimitsByLicense('stock', 'ings_prods') != -1) {
      this.navCtrl.pop();
    } else {
      this.navCtrl.push(ProductCreateSelectTypePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-stock/tutorial-stock.ts